import {
  Grid as DreiGrid,
  GridProps as DreiGridProps,
} from '@react-three/drei';
import { useLayoutEffect, useRef } from 'react';
import type { Mesh, ShaderMaterial } from 'three';

import { isolateGridUniforms } from './gridMaterialUniforms';

export type GridProps = Partial<
  Pick<
    DreiGridProps,
    | 'args'
    | 'cellSize'
    | 'cellThickness'
    | 'cellColor'
    | 'sectionSize'
    | 'sectionThickness'
    | 'sectionColor'
    | 'fadeDistance'
    | 'followCamera'
    | 'castShadow'
    | 'infiniteGrid'
    | 'renderOrder'
  >
>;

export default function Grid({
  args,
  cellSize = 1,
  cellThickness = 1,
  cellColor = '#7A7A7A',
  sectionSize,
  sectionThickness,
  sectionColor = '#7A7A7A',
  fadeDistance = 35,
  followCamera = false,
  castShadow = false,
  infiniteGrid = true,
  renderOrder = -2,
}: GridProps) {
  const gridRef = useRef<Mesh>(null);

  useLayoutEffect(() => {
    const material = gridRef.current?.material as ShaderMaterial | undefined;
    if (material) isolateGridUniforms(material, cellColor, sectionColor);
  }, [cellColor, sectionColor]);

  return (
    <DreiGrid
      ref={gridRef}
      args={args}
      cellSize={cellSize}
      cellThickness={cellThickness}
      cellColor={cellColor}
      sectionSize={sectionSize}
      sectionThickness={sectionThickness}
      sectionColor={sectionColor}
      fadeDistance={fadeDistance}
      followCamera={followCamera}
      castShadow={castShadow}
      infiniteGrid={infiniteGrid}
      renderOrder={renderOrder}
      name="DreiGrid"
    />
  );
}
